import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Menu, MenuDivider, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import {
    ColorFill20Regular,
    Copy20Regular,
    DataBarVertical20Regular,
    Delete20Regular,
    DocumentCopy20Regular,
    Edit20Regular,
    Link20Regular,
    MoreHorizontal20Regular,
    Open20Regular,
    QrCode20Regular,
} from '@fluentui/react-icons';
import IPoll from '../../model/IPoll';
import { IPollActions } from './usePollActions';

export interface IPollRowMenuProps {
    poll: IPoll;
    actions: IPollActions;
    className?: string;
    size?: 'small' | 'medium';
}

/** «…» menu used by table rows and mobile cards. */
const PollRowMenu: React.FC<IPollRowMenuProps> = ({ poll, actions, className, size = 'small' }) => {
    const navigate = useNavigate();
    const id = encodeURIComponent(poll.Id ?? '');
    const hasLink = !!actions.surveyUrl(poll);

    return (
        <Menu positioning="below-end">
            <MenuTrigger disableButtonEnhancement>
                <Button
                    className={className}
                    appearance="subtle"
                    size={size}
                    icon={<MoreHorizontal20Regular />}
                    aria-label={`Действия с опросом «${poll.Title ?? ''}»`}
                    onClick={(event) => event.stopPropagation()}
                />
            </MenuTrigger>
            <MenuPopover onClick={(event) => event.stopPropagation()}>
                <MenuList>
                    <MenuItem icon={<Open20Regular />} onClick={() => navigate(`/polls/${id}`)}>Открыть</MenuItem>
                    <MenuItem icon={<DataBarVertical20Regular />} onClick={() => navigate(`/polls/${id}/results`)}>Результаты</MenuItem>
                    <MenuItem icon={<QrCode20Regular />} onClick={() => navigate(`/polls/${id}/qr`)}>QR-код</MenuItem>
                    <MenuItem icon={<ColorFill20Regular />} onClick={() => navigate(`/polls/${id}/branding`)}>Оформление</MenuItem>
                    <MenuDivider />
                    <MenuItem icon={<Link20Regular />} disabled={!hasLink} onClick={() => { void actions.copyLink(poll); }}>
                        Копировать ссылку
                    </MenuItem>
                    <MenuItem icon={<Edit20Regular />} onClick={() => navigate(`/polls/${id}/edit`)}>Редактировать</MenuItem>
                    <MenuItem icon={<DocumentCopy20Regular />} disabled={actions.duplicating} onClick={() => { void actions.duplicate(poll); }}>
                        Дублировать
                    </MenuItem>
                    <MenuDivider />
                    <MenuItem icon={<Delete20Regular />} onClick={() => actions.requestDelete(poll)}>Удалить</MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export { Copy20Regular };
export default PollRowMenu;
